import React, { useState } from 'react';
import Badge from '../../components/common/Badge';
import Button from '../../components/common/Button';
import '../../styles/AboutPage.css';

export default function About() {
  const profileImage = '/profile.jpg';
  const qrImage = '/qr.png';
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('sarthak.basnet5@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="about-page">
      <div className="about-ambient-glow" aria-hidden="true" />

      <div className="about-container">
        {/* Header Section */}
        <header className="about-header">
          <Badge variant="cyan" pulsing size="sm">
            Platform Architect &amp; Research
          </Badge>
          <h1 className="about-title">
            About the <span className="about-title-gradient">Platform</span>
          </h1>
          <p className="about-lead">
            An enterprise-grade decentralized art investment &amp; fractional tokenization platform,
            engineering fair liquid markets for contemporary artists and global collectors.
          </p>
        </header>

        {/* Bento Grid */}
        <div className="about-bento-grid">
          {/* Creator Profile Bento Card */}
          <article className="about-card about-card-profile">
            <div>
              <div className="about-profile-hero">
                <div className="about-avatar-wrap">
                  <div className="about-avatar-halo" />
                  {profileImage ? (
                    <img
                      src={profileImage}
                      alt="Sarthak Basnet - Lead Platform Architect"
                      className="about-avatar-img"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'grid';
                      }}
                    />
                  ) : null}
                  <div
                    className="about-avatar-placeholder"
                    style={{ display: profileImage ? 'none' : 'grid' }}
                  >
                    <span>SB</span>
                  </div>
                </div>

                <div className="about-profile-info">
                  <span className="about-role-tag">Creator &amp; Architect</span>
                  <h2 className="about-name">Sarthak Basnet</h2>
                  <p className="about-headline">
                    Full-Stack Engineer • Distributed Systems • FinTech &amp; Real-time Markets
                  </p>
                </div>
              </div>

              <p className="about-narrative">
                Engineered from the ground up as a high-throughput, sharded art investment ecosystem.
                Currently operating in active experimentation and staging. Designed for low-latency
                WebSocket auctions, cryptographically sealed TitTat fractional ownership, and
                frictionless settlement.
              </p>

              <div className="about-meta-grid">
                <div className="about-meta-item">
                  <span className="about-meta-label">Origin</span>
                  <span className="about-meta-val">Kathmandu, Nepal 🇳🇵</span>
                </div>
                <div className="about-meta-item">
                  <span className="about-meta-label">Status</span>
                  <span className="about-meta-val" style={{ color: 'var(--success, #10b981)' }}>
                    ● Available for Opportunities
                  </span>
                </div>
                <div className="about-meta-item">
                  <span className="about-meta-label">Direct Contact</span>
                  <span className="about-meta-val mono">sarthak.basnet5@gmail.com</span>
                </div>
                <div className="about-meta-item">
                  <span className="about-meta-label">Architecture Core</span>
                  <span className="about-meta-val">React 18 • Flask • MongoDB Shards</span>
                </div>
              </div>
            </div>

            <div className="about-profile-actions">
              <Button
                variant="primary"
                onClick={() => window.open('mailto:sarthak.basnet5@gmail.com?subject=Platform Inquiry', '_blank')}
              >
                ✉️ Send Email
              </Button>
              <Button
                variant="secondary"
                onClick={handleCopyEmail}
                success={copied}
              >
                {copied ? '✓ Copied to Clipboard' : '📋 Copy Address'}
              </Button>
            </div>
          </article>

          {/* Project Access & Licensing Bento Card */}
          <article className="about-card about-card-access">
            <div className="about-qr-display">
              <div className="about-qr-scan-badge">
                <span>⚡ Commercial Inquiries</span>
              </div>

              <div className="about-qr-frame">
                {qrImage ? (
                  <img
                    src={qrImage}
                    alt="Scan for Project Licensing and Access"
                    className="about-qr-img"
                  />
                ) : (
                  <div
                    style={{
                      width: 190,
                      height: 190,
                      background: '#f1f5f9',
                      display: 'grid',
                      placeItems: 'center',
                      color: '#64748b',
                      fontSize: '0.85rem',
                      borderRadius: '12px',
                    }}
                  >
                    QR Code Placeholder
                  </div>
                )}
              </div>

              <h3 className="about-access-title">Project Licensing</h3>
              <p className="about-access-desc">
                Scan the QR code to connect directly regarding codebase licensing, enterprise
                white-label deployment, or commercial partnership opportunities.
              </p>
            </div>

            <div className="about-access-actions">
              <Button
                to="/marketplace"
                variant="secondary"
                size="md"
              >
                Explore Artworks →
              </Button>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}